import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export const GraduateSvg: React.FC = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={10}
      height={10}
      fill='none'
    >
      <path
        fill='#111'
        fillRule='evenodd'
        d='m3.283.748-1.706.748.089.049c.048.027.11.06.138.072.05.023.05.03.05.355 0 .322-.001.334-.057.411-.079.11-.188.355-.209.47a.63.63 0 0 0 .05.35c.184.385.83.385 1.014 0 .096-.2.073-.347-.107-.69l-.11-.212V1.8l.423.148.424.149V2.4l-.001.304-.11.126a2.226 2.226 0 0 0-.372.655c-.055.16-.06.204-.062.508-.002.4.035.546.22.879.324.58.936.984 1.655 1.094.995.152 1.983-.293 2.43-1.094.186-.333.223-.479.221-.88-.001-.303-.006-.346-.062-.507a2.226 2.226 0 0 0-.372-.655l-.11-.126V2.4l-.001-.304.775-.271.853-.3.078-.028L6.718.75C5.779.337 5.006 0 5 0c-.006 0-.779.337-1.717.748Zm1.36 5.766c-.03.005-.141.018-.245.03a4.159 4.159 0 0 0-2.206.961c-.708.61-1.114 1.397-1.177 2.285L1 10h8l-.015-.21c-.062-.872-.448-1.636-1.136-2.249-.589-.525-1.336-.865-2.179-.992-.182-.027-.91-.052-1.027-.035Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
